// Phone number utility functions

// Country codes to dial codes mapping
const countryDialCodes: Record<string, string> = {
  'KE': '+254', // Kenya
  'UG': '+256', // Uganda
  'TZ': '+255', // Tanzania
  'RW': '+250', // Rwanda
  'BI': '+257', // Burundi
  'ET': '+251', // Ethiopia
  'SS': '+211', // South Sudan
  'SO': '+252', // Somalia
  'DJ': '+253', // Djibouti
  'ER': '+291', // Eritrea
  'US': '+1',   // United States
  'GB': '+44',  // United Kingdom
  'IN': '+91',  // India
  'CN': '+86',  // China
  'CA': '+1',   // Canada
  'AU': '+61',  // Australia
  'ZA': '+27',  // South Africa
  'NG': '+234', // Nigeria
  'GH': '+233', // Ghana
  'EG': '+20',  // Egypt
};

/**
 * Formats a phone number with its country code for display
 * @param phone - The phone number
 * @param countryCode - The country code (e.g., 'KE')
 * @returns Formatted phone number with country dial code
 */
export const formatPhoneNumber = (phone?: string, countryCode?: string): string => {
  if (!phone) return 'Not provided';
  
  // If phone already includes a country code, return as is
  if (phone.startsWith('+')) return phone;
  
  // Get the dial code for the country
  const dialCode = countryCode ? countryDialCodes[countryCode] : null;
  
  if (dialCode) {
    // Clean the phone number (remove any leading zeros or spaces)
    const cleanPhone = phone.replace(/^0+/, '').trim();
    return `${dialCode} ${cleanPhone}`;
  }
  
  return phone;
};

/**
 * Validates a phone number format
 * @param phone - The phone number to validate
 * @returns true if valid, false otherwise
 */
export const validatePhoneNumber = (phone: string): boolean => {
  // Basic phone number validation - allows digits, spaces, hyphens, parentheses, and plus sign
  const phoneRegex = /^[+]?[0-9\s\-\(\)]+$/;
  return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 7;
};

/**
 * Gets the dial code for a country
 * @param countryCode - The country code (e.g., 'KE')
 * @returns The dial code (e.g., '+254') or null if not found
 */
export const getDialCode = (countryCode: string): string | null => {
  return countryDialCodes[countryCode] || null;
};

export default {
  formatPhoneNumber,
  validatePhoneNumber,
  getDialCode,
};